@if ((activeStepIndex$ | async) !== undefined) {
  <nav [attr.aria-label]="'checkoutProgress.label' | cxTranslate">
    <div class="cx-nav">
      <ul class="cx-list">
        @for (step of steps$ | async; track step; let i = $index) {
          <li class="cx-item" [class.active]="isActive(i)" [class.disabled]="isDisabled(i)">
            <a [routerLink]="{ cxRoute: step.routeName } | cxUrl" class="cx-link" [class.active]="isActive(i)"
              [class.disabled]="isDisabled(i)" [tabindex]="getTabIndex(i)">
              <span class="number">{{i+1}}</span><span class="name">{{step.name+'Mobile' | cxTranslate}}</span>
            </a>
          </li>
        }
      </ul>
    </div>
  </nav>
}
